import * as React from "react"
import { Dispatch, SetStateAction } from "react"

interface VersionControlProps {
  versionControlSelectedOption: { title: string } | undefined
  setVersionControlSelectedOption: Dispatch<
    SetStateAction<{ title: string } | undefined>
  >
}
export const VersionControl = ({
  versionControlSelectedOption,
  setVersionControlSelectedOption,
}: VersionControlProps) => {
  const data = [
    {
      title: "Choose Version Control",
      options: [
        {
          title: "GitHub",
        },
        {
          title: "Git Lab",
        },
        {
          title: "Git",
        },
      ],
    },
  ]
  return (
    <div className="mt-10 pt-10 container mx-auto">
      <div className="flex gap-1 justify-center">
        <h2 className="text-black lg:text-3xl text-xl font-bold text-center">
          {data[0].title}
        </h2>
        <p className="pt-2 text-black"> (Optional)</p>
      </div>
      <div className="flex justify-center">
        <form className="flex flex-wrap lg:gap-10 gap-3 items-center mt-5">
          {data[0].options.map((option, index) => (
            <div
              onClick={() =>
                setVersionControlSelectedOption(
                  versionControlSelectedOption?.title === option.title
                    ? undefined
                    : option
                )
              }
              key={index}
              className="flex gap-2 items-center"
            >
              <div className="border border-[#7B68EC] rounded-full flex items-center p-1">
                <input
                  className="input-radio"
                  type="radio"
                  id={option.title}
                  value={option.title}
                  name="hire"
                  checked={versionControlSelectedOption?.title === option.title}
                  readOnly
                />
              </div>
              <label className="text-black" htmlFor={option.title}>
                {option.title}
              </label>
            </div>
          ))}
        </form>
      </div>
    </div>
  )
}
